// import React, { useState } from "react";
// import { FaRegCopy } from "react-icons/fa";

// // endDateTime
// export const ThanksScreen = (endDateTime = "") => {
//   debugger;
//   return (
//     <div className="quiz-container">
//       <div className="winner-container centerElement">
//         <div className="winner-header">
//           <div className="winner-icon">
//             <img src="/Images/thumbs-up.png" alt="thumbs-up" />
//           </div>
//           <h2 className="question-title">Thanks for participating!!</h2>
//           <p>
//             Thank you for participating in our contest! Result will be announced
//             {endDateTime &&
//             typeof endDateTime === "string" &&
//             endDateTime.includes(" at ")
//               ? endDateTime.split(" at ")[0]
//               : "soon"}
//             &nbsp; 11:00PM
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

import React from "react";

export const ThanksScreen = ({ endDateTime = "" }) => {
  return (
    <div className="quiz-container">
      <div className="winner-container centerElement">
        <div className="winner-header mb-0">
          <div className="winner-icon">
            <img src="/Images/thumbs-up.png" alt="thumbs-up" />
          </div>
          <h2 className="question-title mt-0 mb-2">
            Thanks for participating!!
          </h2>
          <p>
            Thank you for participating in our contest! Result will be announced
            {endDateTime.includes(" at ")
              ? ` ${endDateTime.split(" at ")[0]}`
              : " soon"}
            &nbsp; at 11:00 PM
          </p>
        </div>
      </div>
    </div>
  );
};
